import { Flex, Span } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import { LuFileSpreadsheet } from 'react-icons/lu';
import { ChevronDownIcon } from './icons/Icon';
import { useI18n } from '@/i18n/I18nContext';
import { Button } from './ui/button';
import { PopoverBody, PopoverCloseTrigger, PopoverContent, PopoverHeader, PopoverRoot, PopoverTitle, PopoverTrigger } from './ui/popover';

const FileExchangePanel = ({ children }: { children: ReactNode }) => {
    const { t } = useI18n();
    return (
        <PopoverRoot lazyMount positioning={{ placement: 'bottom-end', gutter: 8 }}>
            <PopoverTrigger asChild>
                <Button variant='outline' h='10' w={{ base: '10', lg: 'auto' }} minW='10' px={{ base: 0, lg: 3 }}
                    aria-label={t('common.fileExchange.action')} title={t('common.fileExchange.title')}>
                    <LuFileSpreadsheet aria-hidden='true' />
                    <Span hideBelow='lg'>{t('common.fileExchange.action')}</Span>
                    <Span hideBelow='lg' display='inline-flex' aria-hidden='true'
                        css={{ '[aria-expanded="true"] &': { transform: 'rotate(180deg)' } }}>
                        <ChevronDownIcon />
                    </Span>
                </Button>
            </PopoverTrigger>
            <PopoverContent aria-label={t('common.fileExchange.title')}
                w='24rem' maxW='calc(100vw - 2rem)'
                maxH='min(calc(100dvh - 2rem), var(--available-height, 100dvh))' overflowY='auto'>
                <PopoverHeader pe='10'>
                    <PopoverTitle fontWeight='semibold'>{t('common.fileExchange.title')}</PopoverTitle>
                </PopoverHeader>
                <PopoverCloseTrigger />
                <PopoverBody>
                    <Flex gap='4' wrap='wrap' justify='center' css={{ '& > *': { width: 'auto' } }}>{children}</Flex>
                </PopoverBody>
            </PopoverContent>
        </PopoverRoot>
    );
};

export default FileExchangePanel;
